import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { showNotification } from '@/utils/notificationUtils';

export type requestDTO = {
    id?: any;
};

export const archiveFunnel = ({ id}: requestDTO) => {

    return axios.post(`/superadmin/archive-funnel/${id}`, { });

};

type UseAddUserOptions = {
  config?: MutationConfig<typeof archiveFunnel>;
};

export const useArchiveFunnel = ({ config }: UseAddUserOptions = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Funnel archived successfully',
      });
    },
    ...config,
    mutationFn: archiveFunnel,
  });
};



/////////////ARCHIVE multiple funnels 

export type requestDTO1 = {
  funnelIds?: any;
  userIds?:any;
};

export const archiveMultipleFunnel = ({ funnelIds, userIds}: requestDTO1) => {

  return axios.post(`/superadmin/archive-multiple/funnel`, { funnelIds, userIds});

};

type UseAddUser1Options = {
config?: MutationConfig<typeof archiveMultipleFunnel>;
};

export const useArchiveMutipleFunnel = ({ config }: UseAddUser1Options = {}) => {
const { addNotification } = useNotificationStore();
return useMutation({
  onSuccess: () => {
    showNotification({
      type: 'success',
      title: 'Funnel archived successfully',
    });
  },
  ...config,
  mutationFn: archiveMultipleFunnel,
});
};

